import { Map } from 'immutable';
import { createReducerBySpec } from '@Utils/Redux/reducerFactory';

import {
  bulkIdRegisterSetIpAddressReducerType,
  bulkIdRegisterSetDataReducerType,
  bulkIdRegisterSetIsLoadingReducerType,
  bulkIdRegisterSetLoginFailReducerType,
} from './BulkIdRegisterConstants';

export const initialState = Map({
  data: {
    bulkId: '',
    bulkPassword: '',
  },
  ipAddress: null,
  isFormDisabled: false,
  isLoading: false,
  loginFail: null,
});

const spec = {
  [bulkIdRegisterSetIpAddressReducerType]: (state, action) => {
    const { ipAddress } = action.payload;
    return state.set('ipAddress', ipAddress);
  },
  [bulkIdRegisterSetDataReducerType]: (state, action) => {
    const { bulkId, bulkPassword } = action.payload;
    return state.set('data', { bulkId, bulkPassword });
  },
  [bulkIdRegisterSetIsLoadingReducerType]: (state, action) => {
    const { isLoading } = action.payload;
    return state.set('isLoading', isLoading);
  },
  [bulkIdRegisterSetLoginFailReducerType]: (state, action) => {
    const { loginFail } = action.payload;
    return state.set('loginFail', loginFail);
  },
};

export default createReducerBySpec(spec, initialState);
